export default __webpack_public_path__ + "static/media/icon-Connect-Forums.e8c5ec05.svg";